import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { PasswordInput } from "./PasswordInput";

export const ChangePassword = ({ onBack, role }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { authAxios, logout } = useAuth();
  const navigate = useNavigate();

  const handleChange = async () => {
    if (newPassword !== confirmPassword) return toast.error("Passwords don't match");
    if (newPassword.length < 8) return toast.error("Password must be at least 8 characters");
    try {
      await authAxios.post(`/${role}/change-password`, { current_password: currentPassword, new_password: newPassword });
      toast.success("Password changed! Please login again.");
      logout();
      navigate(role === "admin" ? "/admin/login" : "/accountant/login");
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div data-testid="change-password">
      <button onClick={onBack} className="flex items-center gap-2 text-slate-600 mb-6"><ArrowLeft className="w-5 h-5" /> Change Password</button>
      <div className="bg-white rounded-2xl p-6 shadow-sm space-y-4">
        <PasswordInput value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} placeholder="Current Password" testId="current-password" />
        <PasswordInput value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="New Password" testId="new-password" />
        <PasswordInput value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirm Password" testId="confirm-password" />
        <button onClick={handleChange} className="w-full py-3 rounded-full bg-[#1e3a5f] text-white font-bold" data-testid="change-password-btn">Change Password</button>
      </div>
    </div>
  );
};
